// extracted by mini-css-extract-plugin
export default {"container":"Header_container__HGAIb","label":"Header_label__35u8I"};